import {
  HttpLineDemandSurvey,
  HttpLineDemandSurveyListResponse,
  HttpQuestionOption,
  HttpQuestionProp,
  ILineDemandSurveyListParser,
} from "../surveyRepository.types";
import { err, ok, Result } from "neverthrow";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import {
  ILineDemandSurvey,
  IQuestionOption,
  IQuestionProp,
} from "@/domain/entities/survey";

function parseOption(option: HttpQuestionOption): IQuestionOption {
  const questionOption: IQuestionOption = {
    uid: option.uid,
    parentUid: option.parentUid,
    displayText: option.displayText,
  };

  return questionOption;
}

function parseQuestionProp(prop: HttpQuestionProp): IQuestionProp {
  const questionProp: IQuestionProp = {
    no: prop.no,
    key: prop.key,
    type: prop.type,
    label: prop.label,
    options: prop.options?.map(parseOption),
    tempUid: prop.tempUid,
    requiredYn: prop.requiredYn,
    displayOrder: prop.displayOrder,
    autoFillSourceKey: prop.autoFillSourceKey,
  };

  return questionProp;
}

function parseLineDemandSurvey(
  survey: HttpLineDemandSurvey
): ILineDemandSurvey {
  const lineDemandSurvey: ILineDemandSurvey = {
    validAnswerCount: survey.validAnswerCount,
    serviceUid: survey.serviceUid,
    surveyUid: survey.surveyUid,
    surveyIntervalCode: survey.surveyIntervalCode,
    bookTargetYn: survey.bookTargetYn,
    boardTargetYn: survey.boardTargetYn,
    titleTemplateValue: survey.titleTemplateValue,
    surveyTypeCode: survey.surveyTypeCode,
    surveyCode: survey.surveyCode,
    title: survey.title,
    questionProps: survey.questionProps?.map(parseQuestionProp),
    useBeginDtm: survey.useBeginDtm,
    useEndDtm: survey.useEndDtm,
  };

  return lineDemandSurvey;
}

@injectable()
export class LineDemandSurveyListParser implements ILineDemandSurveyListParser {
  constructor() {}

  toDomain(
    response: HttpLineDemandSurveyListResponse
  ): Result<ILineDemandSurvey[], ParseError> {
    try {
      const lineDemandSurveyList =
        response.data?.map(parseLineDemandSurvey) ?? [];
      return ok(lineDemandSurveyList);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
